function stripDisplayModeDelimiters(tex: string): string | undefined {
  if (tex.startsWith('$$') && tex.endsWith('$$')) {
    return tex.slice(2, -2).trim();
  }
  if (tex.startsWith('\\[') && tex.endsWith('\\]')) {
    return tex.slice(2, -2).trim();
  }
  return undefined;
}

function stripInlineDelimiters(tex: string): string | undefined {
  if (tex.startsWith('\\(') && tex.endsWith('\\)')) {
    return tex.slice(2, -2).trim();
  }
  if (tex.startsWith('$') && tex.endsWith('$')) {
    return tex.slice(1, -1).trim();
  }
  return undefined;
}

export function stripArithmatexDelimiters(text: string): string {
  const tex = text.trim();
  return stripDisplayModeDelimiters(tex) ?? stripInlineDelimiters(tex) ?? tex;
}
